import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { CollapseContent } from '../../../../../../../components/Collapse/CollapseContent'
import { RouteColumn, RouteRow } from '../../../../../../../components/layout'
import { SelectInput } from '../../../../../../../components/layout/form/input'
import { FinishedDateTimeInput } from '../../../../../../../components/layout/form/input/DateTimeInput'
import { format } from 'date-fns'
import { Time } from '../../../../../../../types/time'
import { TowingRecordJobStatus } from '../../../../../../../common/types'
import { serviceTypeOptions } from '../../../../../../TowingOrderPage/options'
import { DefaultProps, FinishedAtDestinationProps } from './FinishedForm'
import { useSettings } from '../../../../../../Parameters'
import { routeSubformMessages } from '../../messages'
import { translateInputOptions } from '../../../../../../../util/translateInputOptions'

export const FinishedAtDestinationForm: React.FunctionComponent<FinishedAtDestinationProps & DefaultProps> = ({
  setValue,
  action,
}) => {
  const intl = useIntl()
  const translatedServiceTypeOptions = translateInputOptions(serviceTypeOptions, intl.formatMessage)
  const [edit, setEdit] = useState<boolean>(action === 'edit-finished')
  const settings = useSettings()

  useEffect(() => {
    if (action === 'edit-finished') {
      if (!edit) setEdit(true)
    } else {
      if (edit) setEdit(false)
    }
  }, [edit, action, setEdit])

  const options = (settings && settings.towingReasons) || []

  return (
    <>
      <CollapseContent>
        <RouteRow columns={`1fr 1fr 1fr`}>
          <RouteColumn>
            <SelectInput label={intl.formatMessage(routeSubformMessages.action)} name="serviceType" options={translatedServiceTypeOptions} disabled required />
          </RouteColumn>
          <RouteColumn>
            <SelectInput
              label={intl.formatMessage(routeSubformMessages.reason)}
              name="towingReason"
              options={options.map((label: string) => ({
                label,
                value: label,
              }))}
              required
              disabled={!edit}
            />
          </RouteColumn>
          <RouteColumn>
            <FinishedDateTimeInput
              name="finishRoute"
              label={intl.formatMessage(routeSubformMessages.completionTime)}
              customOnChange={() => {
                const value = (format(new Date(), 'HH:mm') as unknown) as Time
                setValue('finishRoute.finishedTime', value)
                setValue('finishRoute.finishedDate', new Date())
              }}
              required
              disabled={!edit}
              showCurrentTimeBtn
            />
          </RouteColumn>
        </RouteRow>
      </CollapseContent>
    </>
  )
}

export const finishedAtDestinationEditableJobStatuses = [TowingRecordJobStatus.finished_at_destination]
